<template>
  <ViceButton
    @click="handleOtoscopeConnection"
    circle
    white
    :showNotification="isActive"
    style="padding: 0 !important"
    :btnDescription="btnDescription"
    :class="{ 'sm:bg-vice-teal-600 hover:bg-vice-teal-700': isActive }"
    class="w-12 h-12 border-none bg-vice-light-grey"
    :disabled="isConnected"
  >
    <ViceLoader colorClass="text-vice-teal-700" class="left-2" v-if="loading" />

    <template v-else>
      <ViceOtoscope class="w-12 h-12" :pathFill="!isActive ? '#0F766E' : '#fff'" />
    </template>
  </ViceButton>
</template>

<script>
import { computed, ref } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';
import useLocalStreamingDevicesStore from '@/Stores/useLocalStreamingDevicesStore';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import ViceOtoscope from '../Icons/ViceOtoscope.vue';
import ViceLoader from '../Loaders/ViceLoader.vue';
import { OTOSCOPE_LABELS, EXTERNAL_CONNECTED_VIDEO_DEVICES } from '@/Utils/vice-constants';

export default {
  name: 'AddOtoscopeButton',
  components: {
    ViceButton,
    ViceOtoscope,
    ViceLoader,
  },
  setup() {
    const loading = ref(false);
    const multiCameraDevicesStore = useLocalStreamingDevicesStore();
    const sessionStore = useSessionStore();
    const isActive = computed(() =>
      multiCameraDevicesStore.allExternalConnectedVideoDevices.find(
        (deviceName) => deviceName === EXTERNAL_CONNECTED_VIDEO_DEVICES.OTOSCOPE,
      ),
    );
    const isConnected = computed(
      () =>
        !multiCameraDevicesStore.groupedDeviceAsAudioAndVideo.VIDEO.Camera.find((device) =>
          OTOSCOPE_LABELS.some((singleLabel) => device.label.includes(singleLabel)),
        ),
    );

    const btnDescription = computed(() =>
      isActive.value
        ? `Disconnect ${EXTERNAL_CONNECTED_VIDEO_DEVICES.OTOSCOPE}`
        : `Connect ${EXTERNAL_CONNECTED_VIDEO_DEVICES.OTOSCOPE}`,
    );

    const handleOtoscopeConnection = async () => {
      try {
        loading.value = true;
        sessionStore.toggleControlPanel(true);

        if (isActive.value) {
          console.log('REMOVE FROM PRECONSULT');
          await multiCameraDevicesStore.removeExternalVideoDevice(
            EXTERNAL_CONNECTED_VIDEO_DEVICES.OTOSCOPE,
          );
        } else {
          await multiCameraDevicesStore.addExternalVideoDevice(
            sessionStore.sessionId,
            EXTERNAL_CONNECTED_VIDEO_DEVICES.OTOSCOPE,
            OTOSCOPE_LABELS,
          );
        }
        multiCameraDevicesStore.markSessionSetupAsChanged();
      } catch (error) {
        console.error({ error });
      } finally {
        loading.value = false;
      }
    };

    return {
      isConnected,
      isActive,
      loading,
      btnDescription,
      handleOtoscopeConnection,
    };
  },
};
</script>
